const BASEURL = 'https://backend.staging.mymedsph.com';

export const environment = {
  production: true,
  offline: false,
  url: BASEURL,
  acctUrl: BASEURL + '/acct',
  mstfUrl: BASEURL + '/mstf',
  prctUrl: BASEURL + '/prct',
  sysUrl: BASEURL + '/sys',
  rptUrl: BASEURL + '/rpt',
  apiUrl: 'https://dataapi.staging.mymedsph.com/api/dental',
  apiUrlV2: 'https://dataapi.staging.mymedsph.com/api',
  baseApiUrl: 'https://dataapi.staging.mymedsph.com/api',
  baseProdApiUrl: 'https://dataapi.staging.mymedsph.com/api',
  clientID: 'AT2X1ZXJlMWdP7xRm9FI_dH9NGvgvcffalymxCL6lpN4YQirtX5lxcB7teqGna8HKjr06Fri0ebIWSZo',
  version: '1.0.0',
  splitAuthorizationKey: 'jkj9a66rgnl2lsagsgv3qqcbrk77famookuq',
  features: {
    patientActivity: true, // Enable staging review; production remains hidden.
    webSpeechTranscription: true
  },

  googleAnalyticsId: 'G-ZX304YYCMD',
  intercomAppId: 'f8bgx8io',

  ECHO_CONFIG: {
    broadcaster: 'pusher',
    key: 'MyMedsPHNotif',
    wsHost: 'dataapi.staging.mymedsph.com',
    auth: {},
    authEndpoint: 'https://dataapi.staging.mymedsph.com/api/broadcasting/auth',
    // host: 'https://data.mymedsph.com',
    wsPort: 6002,
    wssPort: 6002,
    disableStats: true,
    forceTLS: true,
    encrypted: true,
    enabledTransports: ['ws', 'wss']
  }
};
